// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pkpiEntity from './entities/pkpi.json';
import pkpiMenu from '../pages/pkpi/menu.json';
import pkpiFullForm from '../pages/pkpi/forms/full.json';
import pkpiContextForm from '../pages/pkpi/forms/context.json';
import pkpiMiniForm from '../pages/pkpi/forms/mini.json';
import pkpiLookupForm from '../pages/pkpi/forms/lookup.json';
import pkpiTableView from '../pages/pkpi/views/table.json';
import pkpiStagesView from '../pages/pkpi/views/stages.json';
import pkpiCardsView from '../pages/pkpi/views/cards.json';
import pkpiInlineView from '../pages/pkpi/views/inline.json';
import pkpiBacklogView from '../pages/pkpi/views/backlog.json';
import pkpiSplitView from '../pages/pkpi/views/split.json';
import pkpiCalendarView from '../pages/pkpi/views/calendar.json';
import pkpiDashboardView from '../pages/pkpi/views/dashboard.json';

/** Тип запису «KPI» зі сторінками пакета: меню, форми та подання з pages/pkpi/. */
export const pkpiDefinition: IRecordTypeDefinition = {
  ...pkpiEntity,
  views: assembleViewSet({
      table: pkpiTableView,
      stages: pkpiStagesView,
      cards: pkpiCardsView,
      inline: pkpiInlineView,
      backlog: pkpiBacklogView,
      split: pkpiSplitView,
      calendar: pkpiCalendarView,
      dashboard: pkpiDashboardView,
  }),
  form: pkpiFullForm,
  forms: { full: pkpiFullForm, context: pkpiContextForm, mini: pkpiMiniForm, lookup: pkpiLookupForm },
  menu: pkpiMenu,
} as IRecordTypeDefinition;
